import { createContext, useContext } from 'react';

const OktaContext = createContext(null);

export const useOktaAuth = () => useContext(OktaContext);

export default OktaContext;
